import React from 'react';

interface UnreadBadgeProps {
  count?: number;
  className?: string;
}

const formatCount = (count: number) => (count > 99 ? '99+' : String(count));

const UnreadBadge: React.FC<UnreadBadgeProps> = ({ count = 0, className = '' }) => {
  if (!count) {
    return null;
  }

  return (
    <span className={`unread-badge ${className}`.trim()} aria-label={`${count} unread messages`}>
      {formatCount(count)}
    </span>
  );
};

export default UnreadBadge;
